/**
 * Portrait + background changer locale pack: ar
 */

module.exports = {
  "portrait": {
    "overview": [
      "Miral AI Background Remover مجاني بعد تسجيل الدخول، ويعمل جيداً لصور البورتريه من الرأس إلى الكتفين: صور LinkedIn، صور السيرة الذاتية، صور الملف الشخصي على WeChat أو Instagram، والنسخ الشفافة لقصات الهوية.",
      "ارفع صورة JPG أو PNG أو WebP حادة بحجم حتى 15 ميغابايت. يكتشف الذكاء الاصطناعي الشخص تلقائياً. قبل التنزيل، كبّر الشعر المتطاير والنظارات والأقراط وخط الياقة.",
      "ملف PNG الشفاف ليس صورة هوية بيضاء أو زرقاء جاهزة. احتفظ أولاً بالنسخة الشفافة الرئيسية، ثم أضف اللون المطلوب واقطع إلى الحجم الرسمي للنموذج الذي تقدّم به."
    ],
    "practice": [
      "أبدأ دائماً بالأصل من الكاميرا متى أمكن. مصغّرات تطبيقات الدردشة وفلاتر التجميل الثقيلة تليّن حواف الشعر وتُصعّب الحفاظ على إطارات النظارات.",
      "أضع القص دائماً على لوحة فاتحة وأخرى داكنة. هذا الفحص وحده يكشف الهالات الباهتة والشعيرات الناقصة التي تبدو سليمة في المعاينة الصغيرة."
    ],
    "compareIntro": "استخدم هذا الدليل للأشخاص—صور الملف الشخصي، صور الهوية، واللقطات الاحترافية. لدليل المنتجات ذات الخلفية البيضاء استخدم دليل التجارة الإلكترونية، ودليل تغيير الخلفية عندما تريد مشهداً لمقهى أو مكتب بعد القص.",
    "workflow": "ارفع بورتريه واضحاً حتى 15 ميغابايت، دع الذكاء الاصطناعي يزيل الخلفية بالكامل، افحص الشعر والنظارات، ثم نزّل PNG شفافاً قبل إضافة الأبيض أو الأزرق أو لون العلامة التجارية.",
    "scenarioIntro": "اختر مهمة البورتريه الأقرب لاستخدامك، ثم افحص الحواف التي تفشل عادة في ذلك الاستخدام.",
    "sec": {
      "tldrTitle": "الخلاصة المختصرة",
      "tldrCols": [
        "ما تحتاجه",
        "التفاصيل"
      ],
      "tldrRows": [
        [
          "السعر",
          "Miral AI Background Remover مجاني بعد تسجيل الدخول"
        ],
        [
          "الرفع",
          "JPG أو PNG أو WebP حتى 15 ميغابايت"
        ],
        [
          "الأنسب لـ",
          "لقطات LinkedIn، صور السيرة، صور الملف الشخصي، نسخ صور الهوية"
        ],
        [
          "التنزيل",
          "PNG شفاف؛ أضف الأبيض أو الأزرق لاحقاً"
        ],
        [
          "افحص بدقة",
          "الشعر، النظارات، الأقراط، الياقة، والكتفين"
        ],
        [
          "ليس هذا المقال",
          "خلفيات المنتجات البيضاء في الأسواق تنتمي لدليل التجارة الإلكترونية"
        ]
      ],
      "tldrP": "حتى سيلفي في الشارع أو لقطة مكتبية مستعجلة يمكن أن تصبح لقطة رأس نظيفة في Miral AI. اقطع الشخص مرة واحدة، احتفظ بالملف الشفاف، ثم ابنِ النسخة البيضاء أو الزرقاء أو بلون العلامة التي تحتاجها فعلاً.",
      "whatTitle": "ما تحتاجه صور الملف الشخصي وصور الهوية ولقطات LinkedIn",
      "whatP1": "المهام الثلاث تشترك في خطوة أولى واحدة: اقطع الشخص بـ Miral AI Background Remover واحتفظ بـ PNG شفاف نظيف. الفرق هو اللون والقص الذي تضيفه بعد ذلك.",
      "whatAvatarP": "ما تحلّه إزالة خلفية صورة الملف الشخصي: سيلفي غرفة النوم ولقطات الشارع تدفن الوجه وسط الفوضى. أزل الخلفية، ضع القص على لون العلامة أو لون صلب، ثم عاين القص الدائري لـ Instagram أو WeChat أو موقعك الشخصي.",
      "galleryAvatarCaption": "مثال صورة ملف شخصي: اليسار سيلفي داخلي مزدحم؛ اليمين القص على لون صلب جاهز لقص دائري للملف.",
      "whatIdP": "ما تحلّه إزالة خلفية صورة الهوية: الطلبات غالباً تتطلب أبيض أو أزرق. لقطة غرفة المعيشة نادراً ما توافق القاعدة. اقطع مرة، أضف اللون المطلوب، ثم اقطع إلى الحجم الرسمي. أعد دائماً التحقق من قواعد النموذج الحالية قبل الإرسال.",
      "galleryIdCaption": "مثال صورة هوية: اليسار خلفية منزل مزدحمة؛ اليمين الشخص نفسه على أبيض نقي لضبط الحجم.",
      "whatLinkedInP": "ما يحلّه قص لقطة LinkedIn: المكاتب المفتوحة تضع الشاشات والزملاء خلفك. خلفية رمادية أو بيضاء هادئة تعيد الانتباه إلى وجهك وملبسك—أول ما يلاحظه مسؤول التوظيف.",
      "galleryLinkedInCaption": "مثال LinkedIn: اليسار سيلفي مكتبي مزدحم؛ اليمين القص على رمادي ناعم جاهز للملف المهني.",
      "whatTipTitle": "نسخة شفافة واحدة للمهام الثلاث",
      "whatTipText": "نزّل PNG الشفاف أولاً. اشتق منه صورة الملف بلون العلامة، وتصدير الهوية أبيض/أزرق، وبطاقة LinkedIn بالرمادي الناعم من الملف نفسه.",
      "howTitle": "أربع خطوات إلى لقطة رأس قابلة للاستخدام",
      "howP": "افتح Miral AI Background Remover، ارفع صورة من الرأس إلى الكتفين، انتظر الاكتشاف التلقائي، ثم كبّر إلى 100٪ على الشعر والنظارات قبل التنزيل. أضف الأبيض أو الأزرق فقط بعد أن تبدو الحافة نظيفة.",
      "howTipTitle": "فضّل الملف الأصلي",
      "howTipText": "فلاتر التجميل الثقيلة وضغط تطبيقات المراسلة يطمس الشعر المتطاير. أصل الكاميرا يفوز تقريباً دائماً.",
      "edgeTitle": "أين تفشل صور البورتريه عادة",
      "edgeCols": [
        "المنطقة",
        "الخطأ الشائع",
        "كيف تفحص"
      ],
      "edgeRows": [
        [
          "الشعر المتطاير",
          "حذف خصلات كأنها خلفية",
          "اعرض على لوحة داكنة وفاتحة"
        ],
        [
          "النظارات",
          "ذراع إطار ناقص أو ثقب في العدسة",
          "كبّر زوايا الإطار"
        ],
        [
          "الأقراط / السلاسل الرفيعة",
          "خطوط معدنية مقطوعة",
          "تتبّع حافة المجوهرات"
        ],
        [
          "خط الياقة والسترة",
          "هالة بيضاء أو كتف مسنّن",
          "ضع على لوحة داكنة"
        ],
        [
          "اللحية أو السوالف",
          "تنعيم الزغب وإزالته",
          "أعد المحاولة بلمسات تجميل أقل على المصدر"
        ]
      ],
      "edgeP": "«يبدو جيداً» في المصغّر لا يكفي. المراجعة بالحجم الكامل على لونين خلفية هي أسرع اختبار صادق.",
      "useTitle": "صورة ملف شخصي، LinkedIn، سيرة ذاتية، وصورة هوية",
      "useCols": [
        "الاستخدام",
        "الخلفية المعتادة",
        "ملاحظة عملية"
      ],
      "useRows": [
        [
          "LinkedIn / مواقع التوظيف",
          "رمادي ناعم أو أبيض أو ضباب نظيف",
          "أبقِ الوجه حاداً؛ الخلفيات الهادئة تفوز"
        ],
        [
          "صورة WeChat / Instagram",
          "لون العلامة أو تدرج بسيط",
          "عاين القص الدائري قبل النشر"
        ],
        [
          "مرفق السيرة الذاتية",
          "أبيض أو رمادي فاتح",
          "اترك مساحة فوق الرأس وتحت الكتفين"
        ],
        [
          "طباعات هوية شائعة",
          "أبيض أو أزرق",
          "أضف اللون المطلوب على PNG الشفاف ثم اقطع"
        ],
        [
          "صور جواز / تأشيرة",
          "اتبع القواعد الرسمية الحالية",
          "اللون والتعبير وقواعد النظارات تختلف حسب البلد"
        ],
        [
          "أغلفة الدورات أو البث",
          "لون العلامة أو مشهد لاحق",
          "اقطع نظيفاً أولاً ثم صمّم الغلاف"
        ]
      ],
      "useTipTitle": "القواعد تتغيّر",
      "useTipText": "قواعد صور التأشيرة والامتحانات تختلف حسب البلد والسنة. الأداة تنظّف الموضوع؛ الامتثال يأتي من قائمة التحقق الرسمية.",
      "hairTitle": "قص الشعر والنظارات",
      "hairItems": [
        "الشعر المتطاير بإضاءة خلفية يحتاج مصدراً أبسط وأعلى تبايناً.",
        "مع النظارات، تأكد أن ذراعي الإطار ومنطقة العدسة يبقيان سليمين.",
        "شعر داكن أمام جدار داكن نقطة انطلاق سيئة—اقترب من جدار أفتح إن أمكن.",
        "كنزة فاتحة أمام جدار أبيض غالباً تفقد حافة الكتف؛ غيّر خلفية التصوير.",
        "التجعيدات الطويلة وشعر الأطفال المتطاير يستحقان تكبيراً إلزامياً 100٪ قبل التنزيل."
      ],
      "hairP": "أشكال الملابس الكبيرة نادراً ما تفسد قص البورتريه. الشعر والنظارات يفعلان. هناك أقضي الدقيقة الإضافية.",
      "troubleTitle": "عندما تبدو لقطة الرأس خاطئة",
      "troubleCols": [
        "المشكلة",
        "السبب المحتمل",
        "جرّب هذا"
      ],
      "troubleRows": [
        [
          "كتل شعر ناقصة",
          "مصدر ناعم أو مضغوط أو بإضاءة خلفية",
          "استخدم أصلاً أحدّ مع تجميل أقل"
        ],
        [
          "حافة باهتة على الوجه أو الكتفين",
          "لون الخلفية القديمة عالق على الحافة",
          "أكد على لوحة داكنة ثم أعد بتباين أعلى"
        ],
        [
          "إطار نظارات مقطوع",
          "انعكاسات قوية تربك المحيط",
          "أعد التصوير بضوء أنعم على العدسات"
        ],
        [
          "الملابس تذوب في الجدار",
          "تباين منخفض بين الموضوع والخلفية",
          "غيّر خلفية التصوير بدل إعادة الملف نفسه"
        ],
        [
          "صورة الهوية تبدو صفراء",
          "توازن أبيض دافئ في المصدر",
          "اقطع أولاً ثم عادل اللون على اللوحة النهائية"
        ]
      ],
      "troubleTipTitle": "غيّر المدخل",
      "troubleTipText": "إعادة رفع السيلفي الناعم نفسه نادراً ما تصلح الشعر. مصدر أنظف يفعل ذلك عادة.",
      "prosConsTitle": "أين تساعد—وأين تقرر أنت",
      "bestTitle": "عادات تجعل صور الملف قابلة للاستخدام",
      "bestItems": [
        "استخدم تأطيراً من الرأس إلى الكتفين مع مساحة قليلة فوق الشعر.",
        "أبقِ التعبير طبيعياً؛ تجنّب تنعيم البشرة الثقيل قبل القص.",
        "افحص PNG على لوحة فاتحة وداكنة في كل مرة.",
        "احفظ النسخة الشفافة الرئيسية وتصدير الهوية الملوّن والقص النهائي كملفات منفصلة.",
        "على منصات التوظيف، الخلفية الهادئة تجعل الوجه والملبس أوضح.",
        "إن احتجت أجواء مقهى أو مكتب لاحقاً، اقطع نظيفاً أولاً ثم اتبع دليل تغيير الخلفية."
      ],
      "miralTitle": "ماذا تفعل بعد القص",
      "miralP": "في Miral AI يمكنك شحذ البورتريه، بناء بطاقة ملف هادئة، أو المتابعة مع Seedream أو FLUX.2 لمشهد غلاف. لاستبدال خلفية أسلوب حياة افتح دليل تغيير الخلفية بالذكاء الاصطناعي. لخلفيات المنتجات البيضاء استخدم دليل التجارة الإلكترونية.",
      "miralLinksTitle": "الخطوات التالية",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "دليل تغيير الخلفية بالذكاء الاصطناعي",
          "path": "/hub/articles/ai-background-changer-online"
        },
        {
          "label": "الدليل العام لإزالة الخلفية بالذكاء الاصطناعي",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "دليل خلفية منتجات التجارة الإلكترونية",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        }
      ],
      "intentsTitle": "مسارات بورتريه شائعة",
      "faqTitle": "أسئلة شائعة قبل الرفع",
      "faqItems": [
        [
          "كيف أزيل خلفية صورة بورتريه مجاناً عبر الإنترنت؟",
          "سجّل الدخول إلى Miral AI، ارفع صورة JPG أو PNG أو WebP من الرأس إلى الكتفين، ثم نزّل PNG الشفاف."
        ],
        [
          "كيف أصنع صورة هوية بيضاء أو زرقاء من سيلفي؟",
          "صدّر PNG شفافاً أولاً، أضف الأبيض أو الأزرق المطلوب، ثم اقطع إلى الحجم الرسمي وأعد التحقق من القواعد الحالية قبل الإرسال."
        ],
        [
          "كيف أصنع لقطة LinkedIn بإزالة الخلفية؟",
          "أزل خلفية المكتب المزدحمة، ضع القص على رمادي ناعم أو أبيض، وأكد حواف الشعر والكتفين قبل الرفع."
        ],
        [
          "هل يمكنني إزالة خلفية صورة WeChat أو Instagram مجاناً؟",
          "نعم. سجّل الدخول، عالج أصل صورة الملف، ثم عاين قصاً دائرياً على لون علامتك."
        ],
        [
          "هل يمكن قص صورة بالنظارات عبر الإنترنت؟",
          "نعم، لكن كبّر الإطار وذراعيه ومنطقة العدسة قبل التنزيل."
        ],
        [
          "ما الأداة التي يمكنني استخدامها لقص الشعر في البورتريه؟",
          "استخدم Miral AI Background Remover مع أصل الكاميرا، ثم افحص الشعر المتطاير على لوحة فاتحة وداكنة."
        ],
        [
          "ما الأداة التي يمكنني استخدامها لتجهيز خلفية صورة جواز السفر؟",
          "اصنع أولاً نسخة بورتريه شفافة رئيسية، ثم صدّر لون الخلفية الرسمي والحجم بالمليمتر."
        ],
        [
          "كيف أصلح الهالة البيضاء بعد إزالة خلفية البورتريه؟",
          "ضع PNG الشفاف على لوحة داكنة لتحديد الحافة، ثم أعد المحاولة بأصل أحدّ وأعلى تبايناً."
        ],
        [
          "كيف أصلح الشعر المتطاير الناقص في صور التجعيد أو الأطفال؟",
          "تجنّب التجميل الثقيل ومصغّرات الدردشة. استخدم أصلاً أوضح وراجع بتكبير 100٪ قبل التنزيل."
        ],
        [
          "هل يمكنني معالجة دفعات كثيرة من اللقطات الاحترافية دفعة واحدة؟",
          "الصفحة الحالية تعالج صورة واحدة في كل مرة حتى يمكن مراجعة كل حافة شعر."
        ],
        [
          "ما الفرق بين خلفية هوية شفافة وبيضاء؟",
          "PNG الشفاف يقبل أي لون لاحق. تصدير الهوية الأبيض يحتوي بالفعل بكسلات بيضاء للنماذج والسيرة."
        ],
        [
          "كيف أغيّر الخلفية إلى مشهد مقهى أو مكتب بعد ذلك؟",
          "بعد أن يجتاز PNG الشفاف المراجعة، اتبع دليل تغيير الخلفية بالذكاء الاصطناعي وتحقق من تطابق الإضاءة."
        ]
      ]
    },
    "linksTitle": "تابع في Miral AI",
    "linksIntro": "احتفظ بنسخة البورتريه الشفافة الرئيسية، ثم حسّنها أو ابنِ بطاقة ملف أو انتقل إلى مشهد أسلوب حياة.",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "دليل تغيير الخلفية بالذكاء الاصطناعي",
        "path": "/hub/articles/ai-background-changer-online"
      },
      {
        "label": "الدليل العام لإزالة الخلفية بالذكاء الاصطناعي",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "دليل خلفية منتجات التجارة الإلكترونية",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "اختر صورة واضحة من الرأس إلى الكتفين",
        "text": "استخدم JPG أو PNG أو WebP حتى 15 ميغابايت مع وجه وكتفين ظاهرين بالكامل."
      },
      {
        "title": "أزل الخلفية تلقائياً",
        "text": "يكتشف Miral AI Background Remover الشخص ويمسح الخلفية بالكامل—دون رسم محيط يدوي."
      },
      {
        "title": "افحص الشعر والنظارات",
        "text": "كبّر الشعر المتطاير والإطارات والأقراط وخط الياقة."
      },
      {
        "title": "نزّل PNG الشفاف ثم أضف اللون",
        "text": "احتفظ بالنسخة الرئيسية، ثم أضف أبيض أو أزرق أو رمادي أو لون العلامة للاستخدام النهائي."
      }
    ],
    "pros": [
      "مصمّم لحواف البورتريه المستخدمة في صور الملف وصور الهوية",
      "لا حاجة لأداة القلم في Photoshop للشعر",
      "PNG شفاف واحد يمكن أن يصبح ألوان خلفية كثيرة",
      "معالجة مجانية في المتصفح بعد تسجيل الدخول"
    ],
    "cons": [
      "الشعر الدقيق ما زال يحتاج فحصاً بالحجم الكامل",
      "الإضاءة الخلفية أو التباين المنخفض قد يليّن الحواف",
      "صورة واحدة في كل مرة على الصفحة الحالية",
      "قواعد الهوية الرسمية ما زالت تحتاج تحققاً يدوياً من الامتثال"
    ],
    "tips": [
      {
        "title": "افحص لونين للوحة",
        "text": "الخلفيات الفاتحة والداكنة تكشف الهالات والشعيرات الناقصة بسرعة."
      },
      {
        "title": "احمِ النظارات والمجوهرات",
        "text": "كبّر أذرع الإطار وزوايا العدسة والسلاسل الرفيعة قبل التنزيل."
      },
      {
        "title": "افصل النسخة الرئيسية عن تصدير الهوية",
        "text": "لا تستبدل PNG الشفاف بملف أبيض أو أزرق مسطّح."
      },
      {
        "title": "أبقِ الفلاتر خفيفة",
        "text": "التجميل الثقيل يليّن الحواف الدقيقة التي يحتاجها النموذج."
      },
      {
        "title": "اعرف أي دليل تفتح لاحقاً",
        "text": "استبدال المشهد → مغيّر الخلفية. أبيض المنتجات → دليل التجارة الإلكترونية."
      }
    ],
    "scenarios": [
      {
        "title": "إزالة خلفية لقطة LinkedIn",
        "text": "اقطع صورة حادة من الرأس إلى الكتفين، ثم ضعها على رمادي ناعم أو أبيض قبل الرفع."
      },
      {
        "title": "قص صورة ملف WeChat أو Instagram",
        "text": "نزّل PNG شفافاً وعاين القص الدائري على لون علامتك."
      },
      {
        "title": "خلفية بيضاء لصورة السيرة الذاتية",
        "text": "احتفظ بالنسخة الشفافة الرئيسية، ثم صدّر ملفاً منفصلاً بخلفية بيضاء لملف PDF."
      },
      {
        "title": "صورة هوية بخلفية زرقاء",
        "text": "أضف الأزرق المطلوب فقط بعد أن تبدو حافة الشعر نظيفة."
      },
      {
        "title": "إزالة الخلفية حول الشعر عبر الإنترنت",
        "text": "استخدم أصل الكاميرا وافحص الشعر المتطاير على لوحة فاتحة وداكنة."
      },
      {
        "title": "قص بورتريه بالنظارات",
        "text": "كبّر زوايا الإطار وذراعيه قبل أن تثق بالتنزيل."
      },
      {
        "title": "تجهيز صورة جواز السفر",
        "text": "اصنع PNG الشفاف أولاً، ثم اتبع قواعد الحجم واللون الحالية للبلد."
      },
      {
        "title": "من سيلفي مكتبي إلى لقطة احترافية",
        "text": "أزل فوضى الممر، أبقِ التعبير طبيعياً، تجنّب الفلاتر الثقيلة."
      },
      {
        "title": "قص شعر الأطفال أو التجعيد",
        "text": "توقّع شعراً متطايراً أكثر؛ راجع دائماً بتكبير 100٪."
      },
      {
        "title": "خلفية بورتريه شفافة مقابل بيضاء",
        "text": "الشفاف يبقى قابلاً لإعادة الاستخدام؛ الأبيض تصدير مسطّح لنموذج محدد."
      },
      {
        "title": "إصلاح الهالة البيضاء على قص الوجه",
        "text": "أكد الحافة على لوحة داكنة، ثم أعد بتباين أقوى في المصدر."
      },
      {
        "title": "من قص البورتريه إلى مشهد مقهى",
        "text": "استخدم دليل تغيير الخلفية بعد أن يجتاز PNG الشفاف المراجعة."
      }
    ],
    "toolFaq": [
      {
        "q": "كيف أزيل خلفية صورة بورتريه مجاناً عبر الإنترنت؟",
        "a": "سجّل الدخول، ارفع بورتريه، ونزّل PNG الشفاف دون تثبيت برنامج سطح مكتب."
      },
      {
        "q": "كيف أصنع صورة هوية بيضاء أو زرقاء من سيلفي؟",
        "a": "أزل الخلفية، احتفظ بـ PNG الشفاف، أضف اللون المطلوب، ثم اقطع إلى الحجم الرسمي."
      },
      {
        "q": "هل يمكنني إزالة خلفية صورة WeChat أو Instagram مجاناً؟",
        "a": "نعم. عالج أصل صورة الملف بعد تسجيل الدخول، ثم عاين القص الدائري على لون علامتك."
      },
      {
        "q": "هل يمكن قص صورة بالنظارات عبر الإنترنت؟",
        "a": "نعم، لكن افحص أذرع الإطار ومناطق العدسة بالحجم الكامل قبل التنزيل."
      },
      {
        "q": "ما الأداة التي يمكنني استخدامها لقص الشعر في البورتريه؟",
        "a": "استخدم Miral AI Background Remover مع أصل حاد وافحص الشعر المتطاير على لوحة فاتحة وداكنة."
      },
      {
        "q": "ما الأداة التي يمكنني استخدامها لتجهيز خلفية صورة جواز السفر؟",
        "a": "أنشئ أولاً نسخة بورتريه شفافة رئيسية، ثم صدّر اللون والحجم الرسميين المطلوبين في النموذج."
      },
      {
        "q": "كيف أصلح الهالة البيضاء بعد إزالة خلفية البورتريه؟",
        "a": "أكد الحافة على لوحة داكنة، ثم أعد المحاولة بمصدر أحدّ وأعلى تبايناً."
      },
      {
        "q": "كيف أصلح الشعر المتطاير الناقص في صور التجعيد أو الأطفال؟",
        "a": "تجنّب التجميل الثقيل ومصغّرات الدردشة؛ استخدم أصلاً أوضح وراجع بتكبير 100٪."
      },
      {
        "q": "هل يمكنني معالجة دفعات كثيرة من اللقطات الاحترافية دفعة واحدة؟",
        "a": "الصفحة الحالية تعالج صورة واحدة في كل مرة."
      },
      {
        "q": "كيف أغيّر الخلفية إلى مشهد مقهى بعد ذلك؟",
        "a": "استخدم PNG الشفاف المراجع مع سير عمل تغيير الخلفية بالذكاء الاصطناعي."
      }
    ]
  },
  "changer": {
    "overview": [
      "تغيير الخلفية يعمل بأفضل شكل على خطوتين: إزالة خلفية مجانية إلى PNG شفاف نظيف، ثم وضع الموضوع في مشهد جديد—ضوء مقهى، مكتب هادئ، جدار علامة، أو ضوء نهار خارجي.",
      "يتولى Miral AI Background Remover القص. يمكن لـ Seedream أو FLUX.2 المساعدة في بناء مشاهد أسلوب الحياة لاحقاً. لا تخلط هذا مع لوحات المنتجات البيضاء بأسلوب Amazon؛ ذلك المسار في دليل التجارة الإلكترونية.",
      "إن بقي للقص حافة باهتة، سيبدو كل مشهد جديد مزيفاً. أصلح الحواف أولاً، ثم فكّر في الأجواء."
    ],
    "practice": [
      "أرفض التركيب حتى يبدو الموضوع الشفاف نظيفاً على لوحة فاتحة وداكنة.",
      "أطابق اتجاه الضوء قبل أن أطابق «الجمال». بورتريه بإضاءة نافذة على شارع ليلي نيون نادراً ما يخدع أحداً."
    ],
    "compareIntro": "استخدم إزالة الخلفية للنسخة الشفافة الرئيسية، وهذا الدليل لمشاهد أسلوب الحياة أو الأغلفة، ودليل البورتريه لألوان الهوية، ودليل التجارة الإلكترونية لخلفيات الأسواق البيضاء.",
    "workflow": "اقطع الموضوع، اختر مشهداً يطابق الإضاءة، ركّب أو ولّد البيئة الجديدة، ثم افحص ظلال التماس ودرجة اللون والحواف قبل التصدير.",
    "scenarioIntro": "اختر هدف المشهد أولاً، ثم أبقِ النسخة الشفافة الرئيسية منفصلة عن كل قص نهائي.",
    "sec": {
      "tldrTitle": "الترتيب الذي يعمل فعلاً",
      "tldrCols": [
        "الخطوة",
        "احتفظ بـ",
        "انتبه"
      ],
      "tldrRows": [
        [
          "1. أزل الخلفية",
          "نسخة PNG شفافة رئيسية من Miral AI",
          "الهالات القديمة تفسد كل مشهد لاحق"
        ],
        [
          "2. اختر مشهداً",
          "مقهى، مكتب، جدار علامة، خارجي",
          "اختر للمهمة لا لعشوائية جمالية"
        ],
        [
          "3. ركّب أو ولّد",
          "صورة أسلوب حياة أو غلاف",
          "طابق اتجاه الضوء ودرجة اللون"
        ],
        [
          "4. راجع",
          "تصدير جاهز للنشر",
          "الحواف والمقياس وإحساس التماس"
        ],
        [
          "افصل عن اللوحات البيضاء",
          "دليل التجارة للـ SKU الأبيض",
          "هذا المقال لاستبدال المشهد"
        ]
      ],
      "tldrP": "تغيير الخلفية ليس فلتر سحر بنقرة واحدة. في Miral AI تعزل الموضوع بـ Background Remover، ثم تعطيه مكاناً جديداً للوقوف. تخطَّ المهمة الأولى فتبدو الثانية دائماً تقريباً ملصقة.",
      "removeTitle": "صور أسلوب الحياة وأغلفة التواصل وملصقات الفعاليات تحتاج كل منها لوحة مختلفة",
      "removeP1": "ألوان الجدران القديمة تلتصق بحواف الشعر والسترة. المسار الثابت يبقى نفسه: Miral AI Background Remover ← نسخة PNG شفافة رئيسية ← مشهد جديد للمهمة. لوحات المنتجات البيضاء في الأسواق تنتمي لدليل التجارة الإلكترونية، لا هنا.",
      "removeLifestyleP": "ما يحلّه تغيير خلفية أسلوب الحياة: ضوء المقهى ومقاعد النافذة وزوايا المنزل تخلق أجواءً—لكن خلفية أصلية فوضوية تجعل الإطار رخيصاً. اقطع نظيفاً، ثم ضع الشخص في مشهد يطابق ضوؤه الوجه.",
      "galleryLifestyleCaption": "مثال أسلوب حياة: اليسار النسخة الشفافة الرئيسية؛ اليمين الشخص نفسه مركّباً في مشهد مقهى مشرق.",
      "removeSocialP": "ما يحلّه تغيير خلفية غلاف التواصل: رؤوس Instagram وXiaohongshu وLinkedIn تحتاج وجهاً واضحاً ومساحة للعنوان. غرفة نوم مزدحمة أو مكتب مفتوح يزدحم الإطار. تدرج علامة أو جدار لون هادئ يضع الشخص على جانب ويترك الجانب الآخر للنص.",
      "gallerySocialCaption": "مثال غلاف تواصل: اليسار النسخة الشفافة الرئيسية؛ اليمين جدار بتدرج علامة مع مساحة للعنوان.",
      "removePosterP": "ما يحلّه تغيير خلفية ملصق الفعالية: الندوات وإطلاق الدورات وإعلانات المحاضرات تحتاج مسرحاً هادئاً أو جدار علامة—لا سيلفي مكتب. بعد القص، ضع الشخص على لوحة علامة ناعمة بمساحة فارغة للعنوان، ثم أضف النص في GPT Image إن لزم.",
      "galleryPosterCaption": "مثال ملصق فعالية: اليسار النسخة الشفافة الرئيسية؛ اليمين جدار علامة ناعم يناسب غلاف محاضرة أو دورة.",
      "removeTipTitle": "افصل النسخة الرئيسية والمشهد وقصات الغلاف",
      "removeTipText": "لا تستبدل PNG الشفاف بتصدير مقهى أو تدرج واحد. ملصق الموسم القادم يجب أن يعيد استخدام القص نفسه.",
      "howTitle": "سير عمل عملي عبر الإنترنت",
      "howP": "افتح Miral AI Background Remover واحصل أولاً على موضوع شفاف موثوق. ثم اختر نوع خلفية: اللون الصلب الأسرع، لوحة صورة حقيقية تالية، وبيئة مولَّدة بالذكاء الاصطناعي الأكثر مرونة. قبل التصدير، تحقق هل ما زال الشخص يبدو مضاءً من العالم نفسه كالخلفية.",
      "howTipTitle": "الضوء يتفوّق على الزخرفة",
      "howTipText": "خلفية أهدأ بضوء متطابق تتفوّق على مشهد درامي يحارب الوجه.",
      "sceneTitle": "اتجاهات مشاهد تميل للنجاح",
      "sceneCols": [
        "الاتجاه",
        "مناسب لـ",
        "انتبه"
      ],
      "sceneRows": [
        [
          "مقهى مشرق / مقعد نافذة",
          "العلامة الشخصية وأغلفة أسلوب الحياة",
          "المصابيح الدافئة قد تدفع البشرة نحو البرتقالي"
        ],
        [
          "مكتب هادئ / ضباب رف كتب ناعم",
          "LinkedIn وصور مرشدي الدورات",
          "إكسسوارات الخلفية يجب أن تبقى أهدأ من الوجه"
        ],
        [
          "ضوء نهار خارجي وخضرة",
          "السفر والعافية ومنشورات أسلوب الحياة",
          "تجنّب ضوء الظهيرة القاسي من الأعلى الذي يحارب الأصل"
        ],
        [
          "جدار علامة صلب أو بتدرج ناعم",
          "ملصقات الفعاليات ورؤوس التواصل",
          "أبقِ التباين عالياً بما يكفي لنص التراكب"
        ],
        [
          "إضاءة مسرح أو كلمة رئيسية",
          "إعلانات المحاضرات",
          "التوهج يجب ألا يقطع الوجه"
        ],
        [
          "زاوية أسلوب حياة منزلية",
          "سرد منتجات ناعم",
          "أبقِ المنظور ومقياس الشخص متسقين"
        ]
      ],
      "sceneP": "ما يستحق النقر غالباً يعني واضحاً لا مزدحماً. شخص نظيف على خلفية هادئة مقصودة يتفوّق عادة على كولاج مزدحم.",
      "qualityTitle": "خمسة مواضع يظهر فيها التزييف",
      "qualityItems": [
        "الشعر والكتفان: هالات بيضاء أو ملوّنة متبقية من الغرفة القديمة.",
        "اتجاه الضوء: إبراز الوجه وضوء النافذة يجب أن يتوافقا.",
        "درجة اللون: بشرة داخلية دافئة على لوحة زرقاء باردة تبدو منقسمة.",
        "المقياس: الشخص يجب ألا يطفو كملصق أو ينكمش في عمق خاطئ.",
        "التماس: لمحة تماس مع الأرض أو الكرسي تجعل التركيب مقنعاً."
      ],
      "qualityTipTitle": "عاين القص مبكراً",
      "qualityTipText": "افحص قص ملف مربع وقص غلاف عريض قبل أن تلتزم بالمشهد النهائي.",
      "vsTitle": "كيف ينفصل هذا المقال عن الآخرين",
      "vsCols": [
        "الدليل",
        "المهمة الرئيسية",
        "افتحه عندما"
      ],
      "vsRows": [
        [
          "إزالة الخلفية العامة بالذكاء الاصطناعي",
          "أي موضوع ← PNG شفاف",
          "تحتاج القص فقط"
        ],
        [
          "خلفية منتجات التجارة الإلكترونية",
          "لوحات منتجات بيضاء / شفافة",
          "امتثال قوائم Amazon وShopify"
        ],
        [
          "إزالة خلفية البورتريه",
          "صور الملف وألوان الهوية",
          "الوجوه والشعر ونسخ الهوية أبيض/أزرق"
        ],
        [
          "مغيّر الخلفية بالذكاء الاصطناعي (هذا)",
          "استبدال المشهد بعد القص",
          "أجواء مقهى أو مكتب أو جدار علامة"
        ]
      ],
      "vsP": "اربط الأدلة الأربعة، لكن أبقِ الكلمات المفتاحية صادقة. لوحات المنتجات البيضاء لا تنتمي لمقال مشهد أسلوب حياة، وصور الهوية الزرقاء للتأشيرة لا تنتمي لعرض تركيب مقهى.",
      "troubleTitle": "عندما يبدو المشهد الجديد خاطئاً",
      "troubleCols": [
        "المشكلة",
        "السبب",
        "الإصلاح"
      ],
      "troubleRows": [
        [
          "هالة ساطعة حول الموضوع",
          "القص ما زال قذراً",
          "عد إلى الإزالة بأصل أعلى تبايناً"
        ],
        [
          "يبدو كملصق",
          "تماس ناقص أو ضوء غير متطابق",
          "ليّن اللوحة أو أضف ظل تماس خفيفاً جداً"
        ],
        [
          "البشرة تصبح رمادية أو برتقالية",
          "تعارض درجة اللون",
          "اختر مشهداً أقرب درجة أو وحّد التدرج"
        ],
        [
          "الشعر يبدو قذراً",
          "ألفا غير مكتمل حول الخصلات",
          "نظّف القص قبل التركيب مجدداً"
        ],
        [
          "شكل المنتج ينحرف في مشهد ذكاء اصطناعي",
          "التوليد غيّر الكائن",
          "ثبّت الهوية؛ دع الذكاء الاصطناعي يخترع البيئة فقط"
        ]
      ],
      "prosConsTitle": "ما يفتحه هذا المسار",
      "bestTitle": "اجعل الاستبدالات تصمد على شاشة الهاتف",
      "bestItems": [
        "لا تتخطَّ النسخة الشفافة النظيفة الرئيسية أبداً.",
        "دع القناة تقرر المشهد: التوظيف يبقى هادئاً، أسلوب الحياة يتنفس، الملصقات تحتاج مساحة عنوان.",
        "إضاءة مصدر بسيطة تجعل الاستبدال أسهل.",
        "عاين دائماً على شاشة بحجم هاتف قبل النشر.",
        "أضف نص العنوان بعد أن يعمل المشهد—يمكن لـ GPT Image المساعدة في نص الملصق.",
        "أرسل وحدات SKU البيضاء في الأسواق إلى دليل التجارة الإلكترونية لتبقى النوايا منفصلة."
      ],
      "miralTitle": "أبقِ السلسلة داخل Miral AI",
      "miralP": "المسار المقترح في Miral AI: Background Remover ← اختيارياً Image Enhancer ← Seedream أو FLUX.2 للبيئة ← GPT Image إن احتجت نص ملصق. لبطاقات الهوية أبيض أو أزرق، عد إلى دليل البورتريه.",
      "miralLinksTitle": "الخطوات التالية",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "دليل البورتريه وصور الهوية",
          "path": "/hub/articles/ai-portrait-background-remover"
        },
        {
          "label": "الدليل العام لإزالة الخلفية بالذكاء الاصطناعي",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "دليل خلفية منتجات التجارة الإلكترونية",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        },
        {
          "label": "GPT Image 1.5",
          "path": "/image-models/gpt-image-ai-image-generator"
        }
      ],
      "intentsTitle": "مهام تغيير خلفية شائعة",
      "faqTitle": "أسئلة عملية",
      "faqItems": [
        [
          "كيف أغيّر خلفية صورة مجاناً عبر الإنترنت؟",
          "سجّل الدخول إلى Miral AI، صدّر PNG شفافاً بـ Background Remover، ثم ضع الموضوع على مقهى أو جدار علامة أو مشهد جديد."
        ],
        [
          "كيف أصنع صورة أسلوب حياة من PNG شفاف؟",
          "ركّب على لوحة بضوء متطابق، افحص التماس ودرجة اللون، وأبقِ النسخة الرئيسية وقصات الغلاف منفصلة."
        ],
        [
          "كيف أغيّر خلفية غلاف تواصل بعد القص؟",
          "بعد أن تجتاز حواف الشعر المراجعة، ضع الموضوع على جانب من تدرج علامة واترك مساحة للعنوان."
        ],
        [
          "هل يمكنني استبدال خلفية سيلفي بمشهد مقهى؟",
          "نعم. اقطع نظيفاً أولاً، ثم ركّب في لوحة مقهى يطابق ضوء نافذتها الوجه."
        ],
        [
          "هل يمكن توليد مشهد ذكاء اصطناعي جديد خلف شخص حقيقي؟",
          "نعم. احتفظ بالموضوع الحقيقي من PNG الشفاف ودع Seedream أو FLUX.2 يخترع البيئة فقط."
        ],
        [
          "ما الأداة التي يمكنني استخدامها لاستبدال خلفية ملصق فعالية؟",
          "استخدم Miral AI Background Remover للقص، ضعه على جدار علامة ناعم، ثم أضف نص العنوان في GPT Image إن لزم."
        ],
        [
          "ما الأداة التي يمكنني استخدامها لاستبدال خلفية غلاف تواصل؟",
          "Background Remover مع جدار بلون علامة أو تدرج. تابع في Seedream أو FLUX.2 عندما تحتاج مشهداً أسلوب حياة أكمل."
        ],
        [
          "كيف أصلح تركيباً خلفية يبدو مزيفاً؟",
          "افحص الهالة واتجاه الضوء ودرجة اللون بهذا الترتيب. إن كانت الحواف قذرة، عد أولاً إلى إزالة الخلفية."
        ],
        [
          "كيف أصلح عدم تطابق ضوء النهار الخارجي عند تغيير الخلفيات؟",
          "طابق اتجاه الشمس؛ تجنّب ضوء الظهيرة القاسي من الأعلى على وجه أُضيء لمشهد داخلي."
        ],
        [
          "هل يمكنني استخدام تغيير الخلفية لغلاف فيديو؟",
          "نعم. صدّر القص الذي يطابق نسبة الغلاف وأبقِ الموضوع داخل المنطقة الآمنة."
        ],
        [
          "ما الفرق بين إزالة الخلفية وتغيير الخلفية؟",
          "الإزالة تعطيك موضوعاً شفافاً. التغيير يضع ذلك الموضوع في مشهد أو لون جديد."
        ],
        [
          "هل يمكنني استخدام هذا لخلفيات منتجات Amazon البيضاء؟",
          "لا. لوحات الأسواق البيضاء تنتمي لدليل التجارة الإلكترونية؛ هذا المقال لمشاهد أسلوب الحياة والأغلفة."
        ]
      ]
    },
    "linksTitle": "ابنِ سير عمل المشهد في Miral AI",
    "linksIntro": "اقطع مرة، احتفظ بالنسخة الشفافة الرئيسية، ثم أنشئ مشاهد أسلوب حياة أو أغلفة أو لوحات ملصقات دون إعادة القناع.",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "دليل البورتريه وصور الهوية",
        "path": "/hub/articles/ai-portrait-background-remover"
      },
      {
        "label": "الدليل العام لإزالة الخلفية بالذكاء الاصطناعي",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "دليل خلفية منتجات التجارة الإلكترونية",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      },
      {
        "label": "GPT Image 1.5",
        "path": "/image-models/gpt-image-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "اقطع موضوعاً نظيفاً أولاً",
        "text": "استخدم Miral AI Background Remover لتنزيل PNG شفاف وتأكيد حواف الشعر أو المنتج."
      },
      {
        "title": "حدد إحساس المشهد الجديد",
        "text": "مقهى أو مكتب هادئ أو ضوء نهار خارجي أو جدار علامة—اختر للقناة."
      },
      {
        "title": "ضع الموضوع في الخلفية الجديدة",
        "text": "ركّب على لوحة تصميم أو تابع في Seedream / FLUX.2 بضوء متطابق."
      },
      {
        "title": "افحص الضوء والمقياس والتماس",
        "text": "ابحث عن الهالات وتعارض الألوان والحجم الخاطئ وغياب إحساس التماس."
      },
      {
        "title": "صدّر القص الذي تحتاجه",
        "text": "احفظ أحجام الغلاف والملف منفصلة وأبقِ النسخة الشفافة الرئيسية دون مساس."
      }
    ],
    "pros": [
      "نسخة شفافة رئيسية واحدة تدعم مشاهد كثيرة",
      "أرخص من إعادة التصوير في كل بيئة",
      "ملاءمة قوية لأغلفة التواصل وإطارات أسلوب الحياة",
      "يتصل بسلاسة بعمل مشاهد Seedream وFLUX.2"
    ],
    "cons": [
      "الضوء غير المتطابق يُقرأ مزيفاً فوراً",
      "حواف القص القذرة تفسد التركيب كله",
      "وحدات SKU البيضاء في الأسواق يجب أن تستخدم دليل التجارة الإلكترونية",
      "مشاهد المنظور المعقدة قد تحتاج صقلاً يدوياً"
    ],
    "tips": [
      {
        "title": "الحواف قبل الأجواء",
        "text": "لا تركّب قصاً ما زال يظهر هالة على لوحة داكنة."
      },
      {
        "title": "طابق الضوء أولاً",
        "text": "اختر لوحات يتوافق ضوءها الرئيسي مع الوجه أو المنتج."
      },
      {
        "title": "أبقِ النسخ الرئيسية منفصلة",
        "text": "PNG الشفاف وتصدير أسلوب الحياة وقصات التواصل يجب أن تكون ملفات مختلفة."
      },
      {
        "title": "اترك مساحة للنص",
        "text": "خلفيات الملصقات تحتاج مناطق أهدأ حيث يمكن للعنوان الجلوس."
      },
      {
        "title": "افصل نوايا البحث",
        "text": "أرسل لوحات Amazon البيضاء إلى مقال التجارة الإلكترونية؛ أبقِ هذا لتغيير المشهد."
      }
    ],
    "scenarios": [
      {
        "title": "استبدال خلفية صورة مجاناً عبر الإنترنت",
        "text": "اقطع الموضوع أولاً، ثم ضعه على لوحة جديدة أو مشهد مولَّد."
      },
      {
        "title": "خلفية بورتريه أسلوب حياة في مقهى",
        "text": "استخدم لوحة بإضاءة نافذة تطابق إضاءة الوجه."
      },
      {
        "title": "خلفية مكتب لصورة احترافية",
        "text": "أبقِ الرفوف والإكسسوارات أهدأ من الشخص."
      },
      {
        "title": "خلفية بلون علامة لغلاف تواصل",
        "text": "PNG شفاف على لون صلب أو تدرج ناعم مع مساحة للعنوان."
      },
      {
        "title": "تغيير الخلفية بعد قص الذكاء الاصطناعي",
        "text": "لا تركّب حتى تجتاز حواف الشعر والسترة فحص لوحتين."
      },
      {
        "title": "مشهد مولَّد بالذكاء الاصطناعي خلف شخص حقيقي",
        "text": "دع Seedream أو FLUX.2 يخترع الغرفة لا وجهاً أو زياً جديداً."
      },
      {
        "title": "استبدال خلفية ملصق فعالية",
        "text": "فضّل جدران علامة نظيفة ليبقى نص العنوان قابلاً للقراءة."
      },
      {
        "title": "مبادلة خلفية بضوء نهار خارجي",
        "text": "طابق اتجاه الشمس؛ تجنّب ضوء الظهيرة من الأعلى على وجه داخلي ناعم."
      },
      {
        "title": "إصلاح تركيب خلفية يبدو مزيفاً",
        "text": "افحص الهالة واتجاه الضوء ودرجة اللون بهذا الترتيب."
      },
      {
        "title": "من PNG شفاف إلى صورة أسلوب حياة",
        "text": "أرشف النسخة الرئيسية وصدّر قصات الغلاف منفصلة."
      },
      {
        "title": "ليس لخلفيات Amazon البيضاء",
        "text": "أرسل لوحات القوائم إلى دليل منتجات التجارة الإلكترونية."
      },
      {
        "title": "قص بورتريه ثم تغيير المشهد",
        "text": "أنهِ مراجعة الشعر في مسار البورتريه، ثم افتح مسار المشهد هذا."
      }
    ],
    "toolFaq": [
      {
        "q": "كيف أغيّر خلفية صورة مجاناً عبر الإنترنت؟",
        "a": "سجّل الدخول، أزل الخلفية الأصلية إلى PNG شفاف، ثم ضع الموضوع على مشهد جديد أو لون صلب."
      },
      {
        "q": "كيف أصنع صورة أسلوب حياة من PNG شفاف؟",
        "a": "ركّب على لوحة بضوء متطابق، افحص التماس ودرجة اللون، وأبقِ النسخة الرئيسية منفصلة عن قصات الغلاف."
      },
      {
        "q": "هل يمكنني استبدال خلفية سيلفي بمشهد مقهى؟",
        "a": "نعم. اقطع الشخص أولاً، ثم ركّب في لوحة مقهى بضوء نافذة مشابه."
      },
      {
        "q": "هل يمكن توليد مشهد ذكاء اصطناعي جديد خلف شخص حقيقي؟",
        "a": "نعم. احتفظ بالموضوع الحقيقي ودع Seedream أو FLUX.2 ينشئ البيئة فقط."
      },
      {
        "q": "ما الأداة التي يمكنني استخدامها لاستبدال خلفية ملصق فعالية؟",
        "a": "استخدم Background Remover للقص، ضعه على جدار علامة هادئ، ثم أضف نص العنوان إن لزم."
      },
      {
        "q": "ما الأداة التي يمكنني استخدامها لاستبدال خلفية غلاف تواصل؟",
        "a": "Background Remover مع جدار بلون علامة أو تدرج؛ تابع في Seedream أو FLUX.2 لمشاهد أسلوب حياة أكمل."
      },
      {
        "q": "كيف أصلح تركيباً خلفية يبدو مزيفاً؟",
        "a": "نظّف الهالة، طابق اتجاه الضوء، ووحّد درجة اللون قبل التصدير."
      },
      {
        "q": "كيف أصلح عدم تطابق ضوء النهار الخارجي عند تغيير الخلفيات؟",
        "a": "طابق اتجاه الشمس وتجنّب ضوء الظهيرة من الأعلى على وجه بإضاءة داخلية."
      },
      {
        "q": "هل يمكنني استخدام تغيير الخلفية لغلاف فيديو؟",
        "a": "نعم. صدّر قص نسبة الغلاف وأبقِ الموضوع داخل المنطقة الآمنة."
      },
      {
        "q": "هل يمكنني استخدام هذا لخلفيات منتجات Amazon البيضاء؟",
        "a": "لا. استخدم دليل خلفية منتجات التجارة الإلكترونية للوحات الأسواق البيضاء."
      }
    ]
  },
  "articles": {
    "ai-portrait-background-remover": {
      "title": "مزيل خلفية بورتريه مجاني بالذكاء الاصطناعي: لقطات رأس وصور ملف وصور هوية",
      "excerpt": "حوّل سيلفي مزدحماً إلى لقطة رأس نظيفة: أزل خلفية البورتريه مجاناً، صدّر PNG شفافاً، ثم أضف أبيض أو أزرق أو لون العلامة لـ LinkedIn والسيرة وصور الملف.",
      "metaTitle": "مزيل خلفية بورتريه مجاني بالذكاء الاصطناعي | Miral",
      "metaDescription": "أزل خلفيات البورتريه مجاناً مع Miral AI. حافظ على تفاصيل الشعر، صدّر قصات PNG شفافة، وابنِ لقطات LinkedIn أو صور هوية بيضاء وزرقاء.",
      "target": {
        "label": "افتح مزيل خلفية البورتريه",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "مزيل خلفية بورتريه مجاني",
        "إزالة خلفية لقطة رأس بالذكاء الاصطناعي",
        "إزالة خلفية صورة LinkedIn",
        "مزيل خلفية صورة هوية",
        "مزيل خلفية صورة ملف شخصي",
        "إزالة الخلفية حول الشعر",
        "صورة سيرة خلفية بيضاء",
        "صورة هوية خلفية زرقاء أونلاين"
      ]
    },
    "ai-background-changer-online": {
      "title": "مغيّر خلفية مجاني بالذكاء الاصطناعي: أسلوب حياة وأغلفة تواصل وملصقات فعاليات",
      "excerpt": "أزل الخلفية القديمة مجاناً، ثم ضع الأشخاص في مشاهد مقهى، أو أغلفة بتدرج علامة، أو جدران ملصقات فعاليات—دون منافسة نية خلفيات التجارة الإلكترونية البيضاء.",
      "metaTitle": "مغيّر خلفية مجاني بالذكاء الاصطناعي أونلاين | Miral",
      "metaDescription": "غيّر خلفيات الصور أونلاين مع Miral AI: اقطع إلى PNG شفاف، ثم ابنِ مشاهد مقهى وأغلفة تواصل وملصقات فعاليات.",
      "target": {
        "label": "افتح مزيل الخلفية بالذكاء الاصطناعي",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "مغيّر خلفية مجاني بالذكاء الاصطناعي",
        "استبدال خلفية صورة أونلاين",
        "تغيير الخلفية بعد القص",
        "استبدال مشهد بالذكاء الاصطناعي",
        "مغيّر خلفية أسلوب حياة",
        "خلفية مقهى للبورتريه",
        "استبدال خلفية غلاف تواصل",
        "PNG شفاف خلفية جديدة"
      ]
    }
  }
}
